import { getCurrentUser, getCurrentUserByTimeInterval } from "./UserAction";

const dispatchGetCurrentUser = (dispatch: Function) => () => {
    dispatch(getCurrentUser());
}

const dispatchGetCurrentUserByTimeInterval = (dispatch: Function) => () => {
    dispatch(getCurrentUserByTimeInterval());
}

const UserDispatch = {
    dispatchGetCurrentUser,
    dispatchGetCurrentUserByTimeInterval
};

export default UserDispatch